'use client'

import { MultipleSelect, MultipleSelectProps } from '@/shared/ui/multiple-select'
import { Skeleton } from '@/shared/ui/skeleton'
import { SelectionDictionaryParams, dictionaryQueries } from '../../api'

interface ComponentProps extends Omit<MultipleSelectProps<string>, 'options'> {
  dictionary: SelectionDictionaryParams
}

export default function Component(props: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(props.dictionary)
  if (isLoading) return <Skeleton className="w-full h-10" />

  return <MultipleSelect idField="id" valueField="id" labelField="name" {...props} options={data || []} />
}
